/**
 * Adds the current /lang prefix to site-relative hrefs so links like
 * `/membership` open the right localized route (`/en/membership` or
 * `/da/membership`). Pass-through for:
 *   - absolute URLs (http://, https://) — external, untouched
 *   - paths that already begin with a 2-letter lang segment (/en/x, /da/x)
 *   - non-path strings (mailto:, tel:, #anchor — they don't start with /)
 *
 * Used by NotificationBanners to fix runtime-config banner links, but
 * lifted into lib/ so any future component (cookie consent, mega-menu
 * CTAs, etc.) can reuse it.
 */
export function withLangPrefix(href: string, lang: string): string {
  if (/^https?:\/\//i.test(href)) return href
  if (!href.startsWith('/')) return href
  if (/^\/[a-z]{2}(?:\/|$)/.test(href)) return href
  return `/${lang}${href}`
}
